import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

@Component({
    selector: 'app-product-not-found-dialog',
    templateUrl: './product-not-found-dialog.html'
})
export class ProductNotFoundDialogComponent {

    constructor(
        public dialogRef: MatDialogRef<ProductNotFoundDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) { }

    closeDialog(res: boolean = false): void {
        this.dialogRef.close(res);
    }

}



// WEBPACK FOOTER //
// ./src/app/dialogs/product-not-found-dialog/product-not-found-dialog.ts